import script from "./ProExpiringModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProExpiringModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProExpiringModal.vue?vue&type=style&index=0&id=4fa33238&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fa33238"]])

export default __exports__